import { graphql } from 'react-relay';
export const LabelsQuery = graphql`
	query LabelsQuerySpaceDirectoryLabelsQuery($start: Int) {
		teamLabels(start: $start, first: 200) {
			nodes {
				name
				id
			}
			pageInfo {
				hasNextPage
			}
		}
	}
`;
